<template>
  <div class="about">
    <div v-if="isError">
      <h2>{{errorMessage}}</h2>
      <a href="/">Go Home</a>
    </div>
    <h1 v-else>Validating...</h1>
  </div>
</template>
<script>
import { API } from '@/models/core'
import { AppState } from '@/state'

export default {
  name: 'login',
  data () {
    return {
      isError: false,
      errorMessage: ''
    }
  },
  mounted () {
    const { token } = this.$route.query
    if (token === undefined || token === null || token === '') {
      this.isError = true
      this.errorMessage = 'Token Missing'
    } else {
      API.loginUser(token)
      const nextUrl = this.$route.query.redirect
      // this.$router.push(nextUrl);
      console.log('Redirecting to', token, nextUrl)
      window.location.href = nextUrl
    }
  }
}
</script>
